import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

import OrderItem from "./OrderItemCard";

import { SessionContext } from "../context/session-context";

const useStyles = makeStyles({
  root: {
    marginTop: 10,
    marginLeft: 20,
  },
  ordertable:{
    height:300,
    overflowY:'scroll'
  },
  containerDiv: {
    border: '1px solid #D2D2D8',
  },
  textField:{
    width: 200,
  },
  textItemFont:{
    fontSize:11
  }
});


export default function OrderDialog(props) {

  const classes = useStyles();
  const [masterRows, setMasterRows] = useState([]);
  const [orderRows, setOrderRows] = useState([]);
  const [orderFilter, setOrderFilter] = useState(0);

   /**
     * First load
     */
    useEffect(() => {
        getClientOrders(parseInt(props.companyid));
    },[props.companyid])


    const handleError = function (err) {
        console.log(err);
        return new Response(JSON.stringify({
          code: 400,
          message: 'Stupid network Error'
        }));
    };

    const getClientOrders = (id) => {
        const abortController = new AbortController();

        const date = new Date();
        const modDate = new Date(date.getFullYear(), date.getMonth(), 1);
        const startDate = modDate.getFullYear()+'-'+ ('0'+(modDate.getMonth()+ 1)).slice(-2) +'-'+('0'+modDate.getDate()).slice(-2);
        const endDate = date.getFullYear()+'-'+ ('0'+(date.getMonth()+ 1)).slice(-2) +'-'+('0'+date.getDate()).slice(-2);

        setOrderRows([]);
        setMasterRows([]);

        let mounted = true;
        (async () => {  
          const res = await fetch(process.env.REACT_APP_FIND_API+'/order/list/company?companyid='+id+'&fromDate='+startDate+'&toDate='+endDate, {
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            signal: abortController.signal,
          }).catch(handleError);
          const data = await res.json();
          if (mounted) {
            //console.log("get orders function: "+JSON.stringify(data));
            if (data.status === "success" && data.orders.length > 0){
                setOrderRows(data.orders);
                setMasterRows(data.orders);
            } else {
                setOrderRows([]);
                setMasterRows([]);
            }
          }
          const cleanup = () => {
            mounted = false;
            abortController.abort();
          };
          return cleanup;
      
      })();
    }

    useEffect(() => {
        if (orderFilter.length > 0){

            var filterArray = JSON.parse(JSON.stringify(masterRows));
    
            filterArray = filterArray.filter(function (c) {
                return c.orderid.toString().charAt(0) === orderFilter.toString().charAt(0);
            });

            if (orderFilter.length > 1)
                filterArray = filterArray.filter(function (c) {
                    return c.orderid.toString().charAt(1) === orderFilter.toString().charAt(1);
            });

            if (orderFilter.length > 2)
            filterArray = filterArray.filter(function (c) {
                return c.orderid.toString().charAt(2) === orderFilter.toString().charAt(2);
            });

            if (orderFilter.length > 3)
            filterArray = filterArray.filter(function (c) {
                return c.orderid.toString().charAt(3) === orderFilter.toString().charAt(3);
            });

            if (orderFilter.length > 4)
            filterArray = filterArray.filter(function (c) {
                return c.orderid.toString().charAt(4) === orderFilter.toString().charAt(4);
            });

            if (orderFilter.length > 5)
            filterArray = filterArray.filter(function (c) {
                return c.orderid.toString().charAt(5) === orderFilter.toString().charAt(5);
            });

            if (orderFilter.length > 6)
            filterArray = filterArray.filter(function (c) {
                return c.orderid.toString().charAt(6) === orderFilter.toString().charAt(6);
            });

            setOrderRows(filterArray);
        } 

    },[orderFilter])

    
  return (
    <div className={classes.root}>
        <Grid container>
            <Grid item xs={12}>
                <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} name="orderFilter" label="Filter" size="small" margin="dense" variant="outlined" value={orderFilter} onChange={e => setOrderFilter(e.target.value)}/> 
            </Grid>
            <Grid item xs={12}>
            <div className={classes.ordertable}>
                {orderRows.map((item, i) =>
                    <OrderItem key={i} item={item} />
                )}
            </div>
            </Grid>
        </Grid>
    </div>
    
  );
}
